import React from "react";
import { Result } from "antd";

export const ErrorServer = () => {
    return (
        <div style={{ height: '84vh' }} className="flex-center">
            <Result status="500" title="500" subTitle="Sorry, something went wrong." />
        </div>
    );
};
